import { CRIAR_PAGINA_SITE, EDITAR_PAGINA_SITE, DELETAR_PAGINA_SITE, CARREGAR_PAGINAS_NA_STORE } from "../constants/constants";
import {List, Map} from 'immutable'

function paginasStateParser(state, action){
    if(action.type == CARREGAR_PAGINAS_NA_STORE){
        let listed = List(action.paginas.map(o => Map(o)))
        return listed
    }
    return state
}

export default (paginasStateOld = List(), action) =>{

    let paginasState =  paginasStateParser(paginasStateOld, action);

    switch(action.type){
        
        case EDITAR_PAGINA_SITE:
            let id_editar = paginasState.findIndex(x => x.get('id') == action.id);
            let {nome, conteudo} = action;
            return paginasState.set(id_editar, Map({...paginasState.get(id_editar).toObject(), nome, conteudo}));
        case DELETAR_PAGINA_SITE:
            let id_deletar = paginasState.findIndex(x => x.get('id')==action.id);
            return paginasState.delete(id_deletar);
        default : return paginasState;        
    }
}


// WEBPACK FOOTER //
// ./src/reducers/paginas.js